import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { ArrowUpRight, MapPin } from "lucide-react";
import { api, resolveImg } from "@/lib/api";
import { Reveal } from "@/components/Reveal";

export const Projects = () => {
  const navigate = useNavigate();
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    api.get("/projects").then((res) => setProjects(res.data)).catch(() => {});
  }, []);

  return (
    <section
      id="projecten"
      data-testid="projects-section"
      className="py-24 md:py-32 bg-[#050505]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal className="max-w-2xl mb-14">
          <span className="text-[#FF1A1A] text-sm font-semibold tracking-[0.25em] uppercase">
            Projecten
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-white mt-5 leading-tight">
            Werk dat voor zich spreekt.
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          {projects.map((p, i) => (
            <motion.div
              key={p.slug}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: (i % 2) * 0.1, ease: "easeOut" }}
              onClick={() => navigate(`/projecten/${p.slug}`)}
              data-testid={`project-card-${i}`}
              className="group cursor-pointer bg-[#0d0d0d] border border-white/5 hover:border-white/15 transition-all duration-300 hover:-translate-y-1 overflow-hidden"
            >
              <div className="relative aspect-[4/3] overflow-hidden bg-[#111]">
                <img
                  src={resolveImg(p.cover) || "https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=1200"}
                  alt={p.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent" />
                <div className="absolute top-4 right-4 w-11 h-11 rounded-full bg-[#FF1A1A] flex items-center justify-center opacity-0 -translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-400">
                  <ArrowUpRight size={20} className="text-white" />
                </div>
              </div>
              <div className="p-6 md:p-7">
                <div className="flex items-center gap-2 text-[#FF1A1A] mb-2">
                  <MapPin size={15} strokeWidth={2} />
                  <span className="text-xs font-semibold tracking-widest uppercase">{p.location}</span>
                </div>
                <h3 className="font-heading text-xl md:text-2xl font-bold text-white">{p.title}</h3>
                <p className="text-white/55 mt-2 text-sm leading-relaxed">{p.work}</p>
                <div className="mt-4 h-[2px] w-10 bg-[#FF1A1A] group-hover:w-20 transition-all duration-300" />
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
